module.exports = __webpack_public_path__ + "img/version_pro.9dd49bd5.png";